// The end of a switch (or a table) that must name every member of a union. Its
// argument is typed `never`, so the switch only typechecks while every member
// has its own case: a member added to the union is a compile error at each such
// site until someone decides what that site does with it. That is how a
// "remember to add it in N places" checklist is kept by tsc instead of by
// memory. It throws if a value outside the union arrives at runtime anyway
// (an old drawing's unknown kind, a cast).
export function unreachable(x: never, what = 'value'): never {
  throw new Error(`unhandled ${what}: ${JSON.stringify(x)}`);
}
